import { AbstractOrchestrationFacade } from '../../common';
import { ReadSettlementConfigurationDto } from '../generated-dto';
import { SettlementConfigurationResponse } from '../model';
export class SettlementConfigurationFacade extends AbstractOrchestrationFacade {
    constructor() {
        super(...arguments);
        this.baseUrl = (merchantId) => `/api/v1/merchants/${merchantId}/settlement-configurations`;
    }
    async get(merchantId) {
        return this.toDto(await this.client.get(`${this.baseUrl(merchantId)}/main`), SettlementConfigurationResponse);
    }
    async update(merchantId, body) {
        return this.toDto(await this.client.put(`${this.baseUrl(merchantId)}/main`, body), ReadSettlementConfigurationDto);
    }
    async create(merchantId, body) {
        return this.toDto(await this.client.post(this.baseUrl(merchantId), body), ReadSettlementConfigurationDto);
    }
}
//# sourceMappingURL=SettlementConfigurationFacade.js.map